/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class ModulesProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get available module hashes
	 *
	 * @return {Promise<Array<string>>}
	 */
	async getModules()
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON('Permissions/Modules/For/User', (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Modules: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get module by hash.
	 *
	 * @param {string} pHash
	 *
	 * @return {Promise<any>}
	 */
	async getModuleByHash(pHash)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(`Modules/FilteredTo/FBV~ModuleHash~EQ~${encodeURIComponent(pHash)}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Module by hash [${pHash}]: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody[0]);
			});
		});
	}
}

module.exports = ModulesProvider;
module.exports.default_configuration = {};
